import React, { FC, memo } from "react";

import StickyButton from "@/common/StickyButton";
import calculateCyclePhase from "@/female/constants/cycle-based-exp/calculateCyclePhase";
import chartByPhase from "@/female/constants/cycle-based-exp/chartByPhase";
import textByPhase from "@/female/constants/cycle-based-exp/textByPhase";
import useAnswers from "@/utils/useAnswers";

interface CyclePhaseProps {
    handleNext(): void;
}

const CyclePhase: FC<CyclePhaseProps> = ({ handleNext }) => {
    const { answers } = useAnswers();
    const phase = calculateCyclePhase({
        startDate: answers.web_cycle_date as unknown as Date,
        periodDuration: Number(answers.web_period_days),
    });
    return (
        <div className="flex h-full grow flex-col justify-between gap-6">
            <div className="grid gap-6">
                <div className="flex flex-col gap-4">
                    <div className="whitespace-pre-line text-zing-24-32 font-semibold text-white female:text-black lg:text-zing-40-48">
                        Some science behind the scenes: you’re in{" "}
                        <span className="capitalize text-zing-warm-tangerine-500">{phase}</span>{" "}
                        phase now
                    </div>
                    <div>{textByPhase[phase]}</div>
                </div>
                <img src={chartByPhase[phase]} alt={phase} />
            </div>
            <StickyButton onClick={() => handleNext()} btnClassName="bg-black">
                Continue
            </StickyButton>
        </div>
    );
};

export default memo(CyclePhase);
